<template>
    <div>
        <nav-secondary :navOptions="navOptions" :navOptionSections="navOptionSections"></nav-secondary>
        <router-view class="flex-page-content flex-container view" :client="client"/>
    </div>
</template>

<script>
import NavSecondary from '@/components/NavSecondary'

export default {
    components: { NavSecondary, },
    props: ['client', ],
    data() {
        let navOptions = [
            {'text': 'Security Users', 'value': 'settings-users', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
            {'text': 'HR Document Library', 'value': 'settings-hr-documents', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
            {'text': 'Change History', 'value': 'settings-change-history', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
        ]

        if (this.client.has_everify) {
            navOptions.splice(1, 0, {'text': 'E-Verify Users', 'value': 'settings-everify-users', 'params': '{hashedClientId: $route.params.hashedClientId}}'})
        }

        return {
            navOptions: navOptions
        }
    },
    mounted() {
        if (this.validRoutes.indexOf(this.$route.name) < 0) {
            this.$router.replace({name: this.validRoutes[0], params: {hashedClientId: this.$route.params.hashedClientId}})
        }
    },
    computed: {
        showAdminOptions() {
            return this.$store.state.user?.is_superuser
        },
        navOptionSections() {
            if (!this.showAdminOptions) {
                return null
            }
            const adminOptions = [
                // {'text': 'Client Set Up', 'value': 'settings-services', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Services', 'value': 'settings-services', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Companies', 'value': 'settings-companies', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Locations', 'value': 'settings-locations', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Organizational Levels', 'value': 'settings-org-levels', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Positions', 'value': 'settings-positions', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Pay Groups', 'value': 'settings-paygroups', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Pay Group Collections', 'value': 'settings-paygroup-collections', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Earnings', 'value': 'settings-earnings', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Deductions', 'value': 'settings-deductions', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Reimbursements', 'value': 'settings-reimbursements', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Taxes', 'value': 'settings-taxes', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Insurance Plans', 'value': 'settings-insurance-plans', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Deliveries', 'value': 'settings-deliveries', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Deferred Compensation Plans', 'value': 'settings-deferred-comp-plans', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Bank Accounts', 'value': 'settings-bank-accounts', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                {'text': 'Clocking IDs', 'value': 'settings-clocking-ids', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
                // {'text': 'ACA', 'value': 'settings-aca', 'params': '{hashedClientId: $route.params.hashedClientId}}'},
            ]
            // AOS clients get their employees, and their accruals, from AOS
            if (!this.client.aos_client) {
                adminOptions.push({'text': 'Accruals', 'value': 'settings-accruals', 'params': '{hashedClientId: $route.params.hashedClientId}}'})
                adminOptions.push({'text': 'Imports', 'value': 'settings-imports', 'params': '{hashedClientId: $route.params.hashedClientId}}'})
            }
            return [
                {
                    options: this.navOptions
                },
                {
                    title: 'Payroll Specialist Only',
                    options: adminOptions
                },
            ]
        },
        validRoutes() {
            let routes
            if (this.navOptionSections?.length) {
                routes = this.navOptionSections.flatMap(sec => sec.options.map(x => x.value))
            } else {
                routes = this.navOptions.map(x => x.value)
            }
            return routes
        }
    }
}
</script>
